import React from 'react'
import { Typography, Stack } from '@mui/material'
import { MainContainer, SettingsContent } from './styles'

interface Props {
  title: string
  description?: string
  disabled?: boolean
  suffix?: React.ReactNode
  prefix?: React.ReactNode
  containerClassName?: string
}

/**
 * This component represents a settings control tile with a title, optional description,
 * prefix and suffix elements.
 * use case examples:
 * prefix can be toggle switch. suffix can be navigation button or toggle switch.
 */
const SettingsControlTile: React.FC<Props> = ({ title, description, disabled, suffix, prefix, containerClassName }) => {
  return (
    <MainContainer className={containerClassName}>
      <Stack gap={2} flexDirection="row" alignItems="center">
        {prefix}
        <SettingsContent>
          <Typography variant="h3">{title ?? ''}</Typography>
          {description && <Typography variant="body2">{description}</Typography>}
        </SettingsContent>
      </Stack>
      {suffix}
    </MainContainer>
  )
}

export default SettingsControlTile
